module.exports = __webpack_public_path__ + "static/media/reverse-proxy.193c2679.png";